import { privateFetch } from "../../utils/CustomFetch"
import { CONSTANT } from "../../utils/Constant"

export const ClientDelete = async (id) => {
    try {
        const response = await privateFetch.delete(`maintenance/client/${id}`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        if (response.data && response.data.error === false && response.data.responseCode === 200) {
            return response.data.message;
        } else {
            throw new Error("Error al eliminar.");
        }
    } catch (error) {
        throw error;
    }
};

export const ClientSaveRequest = async (data) => {
    try {
        const response = await privateFetch.post('maintenance/client', data, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ClientUpdatedRequest = async (data) => {
    try {
        const response = await privateFetch.put('maintenance/client', data, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ClientListRequest = async (prospect, page, limit, companyId, userId, rolId, status, countryPhone, query, leadTagId, startDate, endDate) => {
    let responseData = []
    let url = `maintenance/client/list/${prospect}/${userId}/${rolId}/${page}/${limit}?company=${companyId ?? ''}&status=${status}&countryPhoneId=${countryPhone}${query && query !=='' ? '&query='+query : '' }${leadTagId ? '&leadTagId='+leadTagId : ''}`;
    
    // Add date filters if provided
    if (startDate) {
        url += `&startDate=${startDate}`;
    }
    if (endDate) {
        url += `&endDate=${endDate}`;
    }
    
    await privateFetch
        .get(url, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .then(async (response) => {
            responseData = await response.data
        })
        .catch((error) => {
            throw new Error(error)
        });

    return responseData
}

export const UpdateLead = async (data) => {
    let responseData = {}

    await privateFetch
        .put('maintenance/client', data, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        })
        .then(async (response) => {
            responseData = await response.data
        })
        .catch((error) => {
            throw new Error(error)
        });

    return responseData
}

export const ClientToggleBotPause = async (data) => {
    try {
        const response = await privateFetch.put('maintenance/client', data, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ClientPipelineTotals = async (prospect, userId, rolId, companyId, status, countryPhone, query, leadTagId, startDate, endDate) => {
    let url = `maintenance/client/pipeline-totals/${prospect}/${userId}/${rolId}?company=${companyId ?? ''}&status=${status ?? ''}&countryPhoneId=${countryPhone ?? ''}${query && query !== '' ? '&query=' + query : ''}${leadTagId ? '&leadTagId=' + leadTagId : ''}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    try {
        const response = await privateFetch.get(url, { headers: { ...CONSTANT.HEADER_TYPE } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ClientBulkUpdateLeadValue = async (countryPhoneId, startDate, endDate, value) => {
    try {
        const response = await privateFetch.put('maintenance/client/bulk-update-value', {
            countryPhoneId,
            startDate,
            endDate,
            value,
        }, {
            headers: { ...CONSTANT.HEADER_TYPE },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ClientGetById = async (clientId) => {
    try {
        const response = await privateFetch.get(`maintenance/client/${clientId}`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const AssignLeadRequest = async (clientId, userId, assignedByUserId) => {
    try {
        const response = await privateFetch.put(
            `maintenance/client/${clientId}/assign`,
            { userId, assignedByUserId },
            { headers: { ...CONSTANT.HEADER_TYPE } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};